/**
 * Create image object
 *
 * @param {string} url
 * @return {Promise<CanvasImageSource>}
 */
export const createImage = url => (
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', error => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })
)

/**
 * Read file
 *
 * @param {File} file
 * @return {Promise}
 */
export const readFile = file => (
    new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
    })
)

/**
 * Get mime type of image element
 *
 * @param {CanvasImageSource} image
 * @return {string}
 */
export const getMimeType = image => image?.src?.split?.(',')?.[0].split?.(':')?.[1]?.split?.(';')?.[0] || 'image/jpeg'

/**
 * Get angle in radian
 *
 * @param {number} degreeValue
 * @return {number}
 */
export const getRadianAngle = degreeValue => (degreeValue * Math.PI) / 180
